<template>
  <v-page-content>
    <b-card class="contacts-card" responsive>
      <b-row class="mb-3">
        <b-col sm="12" md="7">
          <h4>
            <em class="fas fa-user-friends"></em> <span class="ml-2">Список пользователей</span>
          </h4>
        </b-col>
        <div sm="12" md="4" class="ml-auto pr-3 addButtons">
          <b-btn
            v-if="showActive"
            variant="outline-primary"
            class="addButton d-flex flex-nowrap align-items-center"
            @click="onActiveShowChanged"
          >
            <em class="far fa-eye-slash mr-1"></em> Показать неактивных
          </b-btn>
          <b-btn v-else
                 variant="outline-primary"
                 class="addButton d-flex flex-nowrap align-items-center"
                 @click="onActiveShowChanged"
          >
            <em class="far fa-eye mr-1"></em> Показать активных
          </b-btn>
        </div>
      </b-row>
      <b-row class="mb-3 sm pagination-row">

      </b-row>

      <div class="ag-grid-vue-users" ref="gridDiv">
        <ag-grid-vue
          style="width: 100%; height: 100%;"
          class="ag-theme-material"
          rowHeight="78"
          :gridOptions="gridOptions"
          :columnDefs="columnDefs"
          :rowData="users"
          :pagination="true"
          :suppressPaginationPanel="true"
          :paginationPageSize="paginationPageSize"
          :currentPage="currentPage"
          @filterChanged="onFilterChanged"
          @sortChanged="onSortChanged"
          @grid-ready="onGridReady"
          @gridSizeChanged="onGridSizeChanged"
          :frameworkComponents="frameworkComponents"
          :context="context"
        >
        </ag-grid-vue>
      </div>
      <b-row class="mt-2">
        <b-col class="col-12">
          <paginator class="usersList__paginator"
                     :pages="pages"
                     :currentPage="currentPage"
                     :pageSize="paginationPageSize"
                     :total="total"
                     :itemsCount="users.length"
                     @toFirstPage="onToFirstPage"
                     @toLastPage="onToLastPage"
                     @previousPage="onPreviousPage"
                     @nextPage="onNextPage"
          />
        </b-col>
      </b-row>

      <b-row class="mb-3 sm pagination-row">
        <div sm="12" md="4" class="ml-auto sm p-3 addButtons">
          <b-btn
            variant="primary"
            class="addButton d-flex flex-nowrap align-items-center"
            v-b-modal.userAddModal
          >
            <em class="fas fa-plus send-icon mr-1"></em>Добавить пользователя
          </b-btn>
          <b-btn
            variant="primary"
            class="addButton d-flex flex-nowrap align-items-center"
            v-b-modal.studentsAddModal
          >
            <em class="fas fa-plus send-icon mr-1"></em>Добавить учеников
          </b-btn>
        </div>
      </b-row>
    </b-card>
    <user-edit-modal :chosen-user="chosenUser" @saveUser="saveUser"/>
    <user-add-modal />
    <students-add-modal />
    <confirm-delete-modal
      :name="chosenUser.name"
      :surname="chosenUser.surname"
      :midname="chosenUser.midname"
      :id="chosenUser.id"
      @userDeleted="fetchUsers({ filters: getFilteredUsers(), sorting: getSorting() })"
    />
    <confirm-password-reset-modal
      :name="chosenUser.name"
      :surname="chosenUser.surname"
      :midname="chosenUser.midname"
      :id="chosenUser.id"
    />
  </v-page-content>
</template>

<script>

import { AgGridVue } from 'ag-grid-vue'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { roleFilters } from '@/config/roles'


import RoleRenderer from '@/components/helpers/renderers/RoleRenderer'
import PartialMatchFilter from '@/components/helpers/filters/PartialMatchFilter'
import ResetFiltersHeader from '@/components/helpers/headers/ResetFiltersHeader'
import Paginator from '@/components/helpers/Paginator.vue'

import AdminActionsRenderer from '@/components/admin/actions/AdminActionsRenderer'

import usersApi from '@/api/users'
import currentUsersApi from '@/api/current-user'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

const UserAddModal = () => import('@/components/admin/modals/users/UserAddModal.vue')
const UserEditModal = () => import('@/components/admin/modals/users/UserEditModal.vue')
const StudentsAddModal = () => import('@/components/students/modals/StudentsAddModal.vue')
const ConfirmDeleteModal = () => import('@/components/admin/modals/users/ConfirmDeleteModal.vue')
const ConfirmPasswordResetModal = () => import('@/components/admin/modals/users/ConfirmPasswordResetModal.vue')

export default {
  name: 'UsersList',
  components: {
    'ag-grid-vue': AgGridVue,
    UserAddModal,
    UserEditModal,
    ConfirmDeleteModal,
    ConfirmPasswordResetModal,
    StudentsAddModal,
    Paginator
  },
  data() {
    return {
      showUserEdit: false,
      showActive: true,
      columnDefs: [
        {
          headerName: 'E-mail',
          field: 'email',
          sortable: true,
          comparator: this.notComparator,
          filter: 'partialMatchFilter',
          suppressSizeToFit: true,
          headerClass: 'ag-grid-table-header',
          cellStyle: {
            'word-break': 'break-all'
          },
          width: 230
        },
        {
          headerName: 'Фамилия',
          field: 'surname',
          sortable: true,
          comparator: this.notComparator,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        {
          headerName: 'Имя',
          field: 'name',
          sortable: true,
          comparator: this.notComparator,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          cellStyle: {
            'word-break': 'break-all'
          },
          width: 150
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          sortable: true,
          comparator: this.notComparator,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        {
          headerName: 'Организация',
          field: 'organization',
          sortable: true,
          comparator: this.notComparator,
          suppressSizeToFit: true,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          cellStyle: {
            'font-size': '0.7rem'
          },
          valueFormatter: this.organizationFormatter
        },
        {
          headerName: 'Роль',
          field: 'roles',
          sortable: false,
          suppressSizeToFit: true,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'roleRenderer',
          width: 220
        },
        {
          headerName: 'Класс',
          field: 'class',
          sortable: true,
          comparator: this.notComparator,
          filter: 'partialMatchFilter',
          headerClass: 'ag-grid-table-header',
          valueFormatter: this.classFormatter,
          width: 140
        },
        {
          headerName: '',
          field: 'actions',
          suppressSizeToFit: true,
          headerClass: 'ag-grid-table-header',
          headerComponent: 'resetFiltersHeader',
          cellRenderer: 'adminActionsRenderer',
          width: 120
        }
      ],
      rowData: null,
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      frameworkComponents: {
        roleRenderer: RoleRenderer,
        partialMatchFilter: PartialMatchFilter,
        adminActionsRenderer: AdminActionsRenderer,
        resetFiltersHeader: ResetFiltersHeader
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      allClasses: ['10', '11'],
      gridWidth: null,
      chosenUser: {
        id: null,
        name: '',
        surname: '',
        midname: '',
        passwordReset: '',
        email: '',
        organisation: '',
        roles: [],
        initialRoles: []
      }
    }
  },
  async created() {
    this.fetchRoles()
    this.fetchUsers({
      filters: [{
        param: 'active',
        needle: this.showActive,
        isStrict: false
      }],
      sorting: ''
    })
    this.debouncedFetchFilteredData = _.debounce((filters, sorting) => {
      this.changePage(1)
      this.debouncedFetch(filters, sorting)
    }, 500)
    this.debouncedFetchSortedData = _.debounce((filters, sorting) => {
      this.debouncedFetch(filters, sorting)
    }, 0)
  },
  computed: {
    ...mapGetters('users', {
      users: 'getUsers',
      getUser: 'getUser',
      currentPage: 'getCurrentPage',
      paginationPageSize: 'getPaginationPageSize',
      total: 'getTotal',
      pages: 'getPages'
    }),
    ...mapGetters('dicts', {
      rolesIds: 'getRoles',
      appLink: 'getLink'
    }),
    ...mapGetters('currentUser', {
      currentUser: 'getCurrentUser'
    })
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.gridDiv.clientWidth >= 1300) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    onGridSizeChanged() {
      if ((this.$refs.gridDiv.clientWidth >= 1300
        && this.$refs.gridDiv.clientWidth > this.gridWidth)
        || (this.$refs.gridDiv.clientWidth >= 1500)) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.gridDiv.clientWidth
    },
    organizationFormatter(params) {
      return params.data.organization !== null
        ? params.data.organization.title
        : ''
    },
    classFormatter(params) {
      return params.data.studentProfile
        ? params.data.studentProfile.class
        : null
    },
    notComparator() {
      return null
    },
    onParentEditClicked(data) {
      this.resetModalInfo()
      this.chosenUser.name = data.name
      this.chosenUser.surname = data.surname
      this.chosenUser.midname = data.midname
      this.chosenUser.passwordReset = data.updatedAt
      this.chosenUser.email = data.email
      this.chosenUser.organisation = data.organization
      this.chosenUser.roles = data.roles.map((el) => el.title)
      this.chosenUser.id = data.id
      this.chosenUser.initialRoles = this.chosenUser.roles
      this.$bvModal.show('userEditModal')
    },
    onParentDeleteClicked(data) {
      this.resetModalInfo()
      if (data.id !== this.currentUser.id) {
        this.chosenUser.name = data.name
        this.chosenUser.surname = data.surname
        this.chosenUser.midname = data.midname
        this.chosenUser.passwordReset = data.updatedAt
        this.chosenUser.id = data.id
        this.$bvModal.show('confirmDeleteModal')
      }
    },
    onParentResetClicked(data) {
      this.resetModalInfo()
      this.chosenUser.name = data.name
      this.chosenUser.surname = data.surname
      this.chosenUser.midname = data.midname
      this.chosenUser.passwordReset = data.updatedAt
      this.chosenUser.id = data.id
      this.$bvModal.show('confirmPasswordResetModal')
    },
    async onParentLoginClicked(data) {
      await currentUsersApi.devLogin(data.id)
      window.location = this.appLink
    },
    resetModalInfo() {
      this.chosenUser.id = null
      this.chosenUser.user = null
      this.chosenUser.name = ''
      this.chosenUser.surname = ''
      this.chosenUser.midname = ''
      this.chosenUser.passwordReset = ''
      this.chosenUser.email = ''
      this.chosenUser.organisation = ''
      this.chosenUser.roles = []
    },
    getFilteredUsers() {
      const filters = this.gridOptions.api.getFilterModel()
      const params = []
      for (const [key, value] of Object.entries(filters)) {
        if (value.value) {
          const param = {}
          if (key === 'roles') {
            const roles = value.value.split(' ')
            const needle = []
            for (let i = 0; i < roles.length; i++) {
              for (const [key, value] of Object.entries(roleFilters)) {
                if (key.toLowerCase().includes(roles[i].toLowerCase())) {
                  needle.push(value)
                }
              }
            }
            param.param = 'roles'
            param.needle = needle
            param.isStrict = false
          } else if (key === 'class') {
            const classes = value.value.split(' ')
            const needle = []
            for (let i = 0; i < classes.length; i++) {
              this.allClasses.forEach((el) => {
                if (el.includes(classes[i])) {
                  needle.push(el)
                }
              })
            }
            param.param = 'class'
            param.needle = needle
            param.isStrict = true
          } else {
            param.param = key
            param.needle = value.value
            param.isStrict = false
          }
          params.push(param)
        }
      }
      params.push({
        param: 'active',
        needle: this.showActive,
        isStrict: false
      })
      return params
    },
    getSorting() {
      const sorting = this.gridOptions.api.getSortModel()
      const sortingQuery = []
      sorting.forEach((el) => {
        const param = []
        if (el.colId === 'class') {
          param[0] = 'studentProfile'
          param[1] = 'class'
          param[2] = el.sort.toUpperCase()
        } else if (el.colId === 'roles') {
          param[0] = 'roles'
          param[1] = 'title'
          param[2] = el.sort.toUpperCase()
        } else if (el.colId === 'organization') {
          param[0] = 'organization'
          param[1] = 'title'
          param[2] = el.sort.toUpperCase()
        } else {
          param[0] = el.colId
          param[1] = el.sort.toUpperCase()
        }
        sortingQuery.push(param)
      })
      return sortingQuery
    },
    onActiveShowChanged() {
      this.showActive = !this.showActive
      this.gridOptions.api.setFilterModel(null)
      this.gridOptions.api.setSortModel(null)
      this.debouncedFetchFilteredData(this.getFilteredUsers(), this.getSorting())
    },
    onFilterChanged() {
      this.debouncedFetchFilteredData(this.getFilteredUsers(), this.getSorting())
    },
    onSortChanged() {
      this.debouncedFetchSortedData(this.getFilteredUsers(), this.getSorting())
    },
    debouncedFetch(filters, sorting) {
      const payload = {}
      payload.filters = filters || ''
      payload.sorting = sorting || ''
      this.fetchUsers(payload)
    },
    resetFilters() {
      if (!this.showActive) {
        this.showActive = !this.showActive
      }
      this.gridOptions.api.setFilterModel(null)
      this.gridOptions.api.setSortModel(null)
    },
    saveUser(user) {
      usersApi.updateUser(user)
        .then(() => {
          this.debouncedFetchSortedData(this.getFilteredUsers(), this.getSorting())
          this.$bvModal.hide('userEditModal')
        })
        .catch((error) => {
          this.pushToasts({
            error: true,
            title: 'Уведомление',
            message: error.response.data.message
          })
        })
    },
    async onPreviousPage() {
      if (this.currentPage > 1) {
        this.changePage(this.currentPage - 1).then(
          this.fetchUsers({ filters: this.getFilteredUsers(), sorting: this.getSorting() }),
        )
      }
    },
    async onNextPage() {
      if (this.currentPage < this.pages) {
        this.changePage(this.currentPage + 1).then(
          this.fetchUsers({ filters: this.getFilteredUsers(), sorting: this.getSorting() }),
        )
      }
    },
    onToFirstPage() {
      if (this.currentPage > 1) {
        this.changePage(1)
        this.fetchUsers({ filters: this.getFilteredUsers(), sorting: this.getSorting() })
      }
    },
    onToLastPage() {
      if (this.currentPage < this.pages) {
        this.changePage(this.pages)
        this.fetchUsers({ filters: this.getFilteredUsers(), sorting: this.getSorting() })
      }
    },
    ...mapActions('users', [
      'fetchUsers',
      'changePage',
      'changePageSize'
    ]),
    ...mapActions('dicts', [
      'fetchRoles'
    ]),
    ...mapActions('toasts', [
      'pushToasts'
    ])
  }
}

</script>

<style lang="scss">
@import "../../sass/vendor/bootstrap/variables";

.ag-header-cell-label {
  justify-content: center;
}

.ag-row .ag-cell {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  justify-content: center;
  text-align: center;
  white-space: normal;
  line-height: 1.4em !important;
}

.ag-grid-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: bold;
}

.ag-row .ag-cell{
  padding: 0 !important;
}

.role-box {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
}

.role-badge {
  font-size: 10px;
  width: 20px !important;
}

.role-badge:nth-child(n+1) {
  margin-right: 5px;
}

.userEditModal__rolesWarning {
  color: #dc3545 !important;
  margin-top: 10px !important;
  margin-bottom: 0 !important;
}

.adminAction {
  margin-right: 10px;
}

.addButtons {
  display: flex;
  flex-direction: row;
}

.addButton:nth-child(n+1) {
  margin-left: 10px;
}

@media only screen and (max-width : 480px) {
  .addButton:nth-child(n+1) {
    margin-left: 0;
    margin-bottom: 10px;
  }

  .addButtons {
    flex-direction: column;
  }
}

.resetFiltersHeader {
  text-align: center;
  align-items: center;
  justify-content: center;
}

.resetFiltersHeader-btn {
  padding: 0 !important;
  width: 80px !important;
  height: 30px;
}

textarea:focus,
textarea:not(focus),
textarea:active {
  outline: none !important;
  box-shadow: none !important;
  border: 1px lightgrey solid !important;
  border-right: none !important;
}

.userModal-header {
  margin-bottom: 30px;
}

.userModalItem {
  margin-bottom: 20px;
}

.userModal-footer {
  margin-bottom: 0 !important;
}

.userModal-confirmButton {
  width: 100%;
}

.usersList__paginator {
  position: relative !important;
  text-align: right !important;
}

.ag-grid-vue-users {
  height: calc(100vh - 340px);
  border-bottom: 1px solid lightgray;
}

.admin-actions-renderer {
  cursor: pointer;
}

</style>
